module.exports = __webpack_public_path__ + "static/media/yunying4.851ed75c.jpg";